/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum OwnerType {
    USER = 'User',
    ORGANISATION = 'Organisation',
}
